export const videos = [
  {
    id: 'vid-1',
    slug: 'dad-educates-son-with-love',
    title: '爸爸用爱教育调皮儿子，温馨亲子时刻感动无数网友',
    description: '一段温馨的父子互动视频走红网络，爸爸在教育调皮儿子时展现出的耐心与爱心，让无数网友感动落泪。教育不只是惩罚，更是爱的传递。视频中爸爸先用讲道理的方式与孩子沟通，最后用一个轻轻的打屁股动作收尾，既达到了教育目的，又让孩子感受到了父爱的温暖。这段视频引发了广大家长对家庭教育方式的深入讨论。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Warm%20family%20scene%20father%20sitting%20on%20sofa%20gently%20talking%20with%20young%20son%20soft%20natural%20window%20lighting%20cream%20and%20beige%20interior%20loving%20parenting%20moment%20editorial%20photography%20emotional%20connection%20minimalist%20home%20decor&width=800&height=450&seq=vid-dad-son-001&orientation=landscape',
    categorySlug: 'parent-child-education',
    categoryName: '亲子教育场景',
    views: 125800,
    date: '2026-07-28',
    duration: '03:25',
    tags: ['亲子教育', '家庭教育', '温馨', '育儿', '热门'],
    featured: true,
  },
  {
    id: 'vid-2',
    slug: 'classic-movie-spanking-scene-review',
    title: '盘点影视剧中十大经典打屁股名场面，你看过几个？',
    description: '从好莱坞经典到华语佳作，我们盘点了影视作品中最令人印象深刻的十个打屁股场景。这些片段或幽默、或感人、或发人深省，成为了影史中不可磨灭的经典瞬间。每个场景背后都蕴含着导演独特的叙事技巧和对人性的深刻洞察。一起来回顾这些让观众记忆犹新的银幕片段吧！',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Classic%20film%20projector%20with%20warm%20golden%20light%20vintage%20movie%20posters%20on%20wall%20nostalgic%20cinema%20aesthetic%20amber%20and%20cream%20tones%20old%20Hollywood%20style%20editorial%20photography%20soft%20dramatic%20lighting&width=800&height=450&seq=vid-movie-review-002&orientation=landscape',
    categorySlug: 'movie-classic-clips',
    categoryName: '影视经典片段',
    views: 98200,
    date: '2026-08-02',
    duration: '08:12',
    tags: ['影视经典', '盘点', '名场面', '电影', '回顾'],
    featured: true,
  },
  {
    id: 'vid-3',
    slug: 'office-prank-spanking-gone-viral',
    title: '办公室搞笑整蛊：同事生日惊喜变惊吓，全场笑翻',
    description: '一则办公室整蛊视频在社交平台爆火！同事们为寿星准备了一个特别的生日惊喜——用充气锤子模仿打屁股的搞笑场景。被整蛊的同事从惊吓到爆笑的反转反应，让整个办公室充满了欢声笑语。视频发布后迅速获得百万点赞，网友纷纷评论"这就是我想要的同事关系"、"笑着笑着就哭了，好羡慕这样的工作氛围"。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Bright%20modern%20office%20interior%20with%20colleagues%20laughing%20around%20desk%20colorful%20balloons%20and%20party%20decorations%20warm%20natural%20lighting%20joyful%20workplace%20atmosphere%20cream%20and%20coral%20accents%20editorial%20photography&width=800&height=450&seq=vid-office-prank-003&orientation=landscape',
    categorySlug: 'funny-prank-videos',
    categoryName: '搞笑整蛊视频',
    views: 256300,
    date: '2026-08-04',
    duration: '02:48',
    tags: ['搞笑', '整蛊', '办公室', '生日', '爆笑'],
    featured: true,
  },
  {
    id: 'vid-4',
    slug: 'teacher-student-funny-moment',
    title: '老师课堂上的幽默惩罚，全班同学笑得前仰后合',
    description: '一位中学老师在课堂上用幽默的方式管理纪律，用充气锤子轻轻拍打不听话学生的屁股作为"惩罚"，结果全班同学笑成一片。老师的这种教育方式既维持了课堂秩序，又活跃了课堂氛围，受到了学生和家长们的一致好评。这段视频在短视频平台获得了超过50万的点赞，成为校园教育创新方式的热门讨论话题。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Bright%20classroom%20with%20students%20laughing%20and%20happy%20teacher%20smiling%20sunlight%20through%20large%20windows%20wooden%20desks%20warm%20beige%20tones%20educational%20environment%20joyful%20learning%20atmosphere%20editorial%20photography&width=800&height=450&seq=vid-classroom-004&orientation=landscape',
    categorySlug: 'school-fun',
    categoryName: '校园趣事',
    views: 187500,
    date: '2026-07-30',
    duration: '01:55',
    tags: ['校园', '老师', '幽默', '课堂', '教育'],
    featured: true,
  },
  {
    id: 'vid-5',
    slug: 'mom-and-daughter-playful-moment',
    title: '母女俩的欢乐下午：打屁股游戏玩出新高度',
    description: '一位年轻妈妈分享了她和女儿在家中玩打屁股游戏的温馨视频。视频中母女俩在客厅里嬉戏玩闹，妈妈轻轻拍打女儿的屁股，女儿则咯咯笑着逃跑，场面温馨又有趣。这则视频引发了关于亲子互动方式的讨论，很多家长表示适当的身体互动游戏可以增进亲子关系，让孩子在笑声中感受到父母的爱。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Warm%20living%20room%20mother%20and%20young%20daughter%20playing%20together%20on%20soft%20rug%20sunlight%20through%20window%20cream%20and%20soft%20pink%20tones%20loving%20family%20moment%20editorial%20photography%20joyful%20atmosphere%20cozy%20home&width=800&height=450&seq=vid-mom-daughter-005&orientation=landscape',
    categorySlug: 'family-happy-moments',
    categoryName: '家庭欢乐时刻',
    views: 143200,
    date: '2026-08-03',
    duration: '04:10',
    tags: ['家庭', '母女', '亲子游戏', '温馨', '育儿'],
    featured: false,
  },
  {
    id: 'vid-6',
    slug: 'anime-spanking-compilation',
    title: '动漫打屁股名场面TOP20，二次元粉丝必看合集',
    description: '精心整理了20个动漫作品中经典打屁股搞笑场景，涵盖《海贼王》、《火影忍者》、《哆啦A梦》、《蜡笔小新》等众多热门动漫。从热血战斗中的搞笑插曲到日常番的温馨互动，每一个片段都让人忍俊不禁。这部合集不仅是对经典动漫的致敬，也是二次元文化中有趣现象的盘点，绝对是动漫爱好者不容错过的精彩内容。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20illustration%20with%20vibrant%20characters%20in%20playful%20poses%20warm%20coral%20and%20amber%20color%20palette%20creative%20artistic%20composition%20Japanese%20manga%20inspired%20aesthetic%20soft%20gradient%20background%20editorial%20style&width=800&height=450&seq=vid-anime-comp-006&orientation=landscape',
    categorySlug: 'animation-clips',
    categoryName: '动漫动画片段',
    views: 201400,
    date: '2026-08-01',
    duration: '10:35',
    tags: ['动漫', '合集', '二次元', '盘点', 'TOP20'],
    featured: true,
  },
  {
    id: 'vid-7',
    slug: 'grandpa-educates-grandson-tradition',
    title: '爷爷的传统教育方式引热议，祖孙情深令人动容',
    description: '一段爷爷用传统方式教育孙子的视频在网络上引发广泛讨论。视频中爷爷用竹条轻轻拍打不听话孙子的屁股，随后又心疼地抱住孙子解释道理。这种传统与现代教育理念的碰撞，让很多网友开始反思家庭教育的本质。视频最后孙子主动抱住爷爷说"爷爷我错了"的画面，让无数人感动落泪，展现了隔代亲情的深厚与温暖。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Elderly%20grandfather%20sitting%20with%20young%20grandson%20in%20traditional%20Chinese%20courtyard%20warm%20afternoon%20sunlight%20wooden%20furniture%20soft%20beige%20and%20terracotta%20tones%20touching%20family%20moment%20editorial%20photography%20emotional%20atmosphere&width=800&height=450&seq=vid-grandpa-007&orientation=landscape',
    categorySlug: 'parent-child-education',
    categoryName: '亲子教育场景',
    views: 89200,
    date: '2026-07-25',
    duration: '05:30',
    tags: ['传统文化', '祖孙', '家庭教育', '热议', '感人'],
    featured: false,
  },
  {
    id: 'vid-8',
    slug: 'dormitory-funny-spanking-game',
    title: '大学宿舍打屁股大赛，室友们的搞笑日常',
    description: '几个大学男生在宿舍里自创了一套打屁股比赛规则，输的人要被其他人用枕头打屁股。这段记录大学宿舍日常的搞笑视频迅速在校园圈传播开来。从制定规则到激烈角逐，再到最后的大笑收场，展现了大学室友之间纯真的友谊和青春活力。网友们纷纷表示"这就是青春啊"、"好怀念大学时光"、"室友就是最珍贵的财富"。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=University%20dormitory%20room%20with%20young%20students%20laughing%20on%20bunk%20beds%20colorful%20pillows%20posters%20on%20wall%20warm%20evening%20lighting%20casual%20fun%20atmosphere%20cream%20and%20coral%20tones%20editorial%20photography%20youthful%20energy&width=800&height=450&seq=vid-dorm-008&orientation=landscape',
    categorySlug: 'school-fun',
    categoryName: '校园趣事',
    views: 167800,
    date: '2026-08-05',
    duration: '03:42',
    tags: ['大学', '宿舍', '室友', '搞笑', '青春'],
    featured: false,
  },
  {
    id: 'vid-9',
    slug: 'husband-wife-playful-fight',
    title: '夫妻搞笑日常：老婆用枕头打老公屁股，结果反被制裁',
    description: '一对年轻夫妻分享了他们在客厅玩闹的搞笑日常。老婆想偷袭老公的屁股，结果反被老公一把抱住，两人在沙发上打闹成一团。视频中两人的笑声非常具有感染力，展示了一种健康有趣的夫妻相处模式。该视频获得了大量已婚网友的共鸣，评论区成了"夫妻搞笑日常"的大型分享现场，大家纷纷晒出自己和伴侣的欢乐互动。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Young%20couple%20playfully%20interacting%20on%20modern%20sofa%20in%20bright%20living%20room%20natural%20window%20lighting%20soft%20cream%20and%20terracotta%20decor%20joyful%20loving%20atmosphere%20editorial%20photography%20warm%20tones%20minimalist%20interior&width=800&height=450&seq=vid-couple-009&orientation=landscape',
    categorySlug: 'family-happy-moments',
    categoryName: '家庭欢乐时刻',
    views: 112400,
    date: '2026-07-29',
    duration: '02:20',
    tags: ['夫妻', '搞笑日常', '家庭', '互动', '甜蜜'],
    featured: false,
  },
  {
    id: 'vid-10',
    slug: 'pet-dog-spanks-owner-funny',
    title: '狗狗用尾巴打主人屁股，宠物搞笑行为大赏',
    description: '一只金毛犬用尾巴不停地拍打主人的屁股，配合狗狗无辜的表情，这个搞笑场景让无数网友捧腹大笑。视频发布后迅速走红，猫咪用爪子拍主人等各种宠物搞笑行为也被网友纷纷投稿。动物行为专家表示，狗狗用尾巴拍打主人通常是表达兴奋和亲近的方式，是一种亲昵的互动行为。这个视频为网友们带来了满满的治愈和快乐。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Golden%20retriever%20dog%20sitting%20next%20to%20owner%20in%20bright%20living%20room%20wagging%20tail%20happily%20warm%20sunlight%20cream%20and%20beige%20interior%20joyful%20pet%20moment%20editorial%20photography%20natural%20light%20playful%20atmosphere&width=800&height=450&seq=vid-pet-dog-010&orientation=landscape',
    categorySlug: 'funny-prank-videos',
    categoryName: '搞笑整蛊视频',
    views: 312600,
    date: '2026-08-06',
    duration: '01:38',
    tags: ['宠物', '狗狗', '搞笑', '动物', '治愈'],
    featured: true,
  },
  {
    id: 'vid-11',
    slug: 'hong-kong-movie-spanking-classic',
    title: '港片经典：周星驰电影中的打屁股喜剧桥段回顾',
    description: '深度回顾周星驰经典喜剧电影中那些令人捧腹的打屁股桥段。从《逃学威龙》到《九品芝麻官》，周星驰用他独特的无厘头喜剧风格，将打屁股这一元素演绎得妙趣横生。这些片段不仅展现了港片黄金时代的辉煌，也成为了华语喜剧电影中不可复制的经典。本文详细分析了每个场景的拍摄手法和喜剧节奏，带您重温那个港片辉煌的年代。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20classic%20cinema%20aesthetic%20vintage%20movie%20theater%20neon%20signs%20warm%20amber%20lighting%20nostalgic%201990s%20atmosphere%20film%20posters%20on%20wall%20golden%20tones%20editorial%20photography%20retro%20style&width=800&height=450&seq=vid-hk-movie-011&orientation=landscape',
    categorySlug: 'movie-classic-clips',
    categoryName: '影视经典片段',
    views: 145600,
    date: '2026-08-03',
    duration: '06:50',
    tags: ['港片', '周星驰', '喜剧', '经典', '回顾'],
    featured: false,
  },
  {
    id: 'vid-12',
    slug: 'anime-doraemon-nobita-spank',
    title: '哆啦A梦里大雄被打屁股的搞笑名场面合集',
    description: '《哆啦A梦》中野比大雄是个"被打屁股专业户"，几乎每一集都有他被妈妈打屁股的场景。本视频整理了最经典的30个大雄挨打场面，从考试零分到弄坏家里物品，各种原因五花八门。这些片段不仅让人捧腹大笑，也成为了几代人共同的童年回忆。弹幕中网友们刷满了"童年回忆"、"原来大雄挨了这么多次打"，引发了一波怀旧热潮。',
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20room%20with%20cartoon%20characters%20bright%20cheerful%20colors%20warm%20coral%20and%20cream%20palette%20Japanese%20animation%20inspired%20illustration%20soft%20gradient%20background%20playful%20nostalgic%20vibe%20editorial%20style&width=800&height=450&seq=vid-doraemon-012&orientation=landscape',
    categorySlug: 'animation-clips',
    categoryName: '动漫动画片段',
    views: 178900,
    date: '2026-07-31',
    duration: '07:25',
    tags: ['哆啦A梦', '大雄', '童年回忆', '动漫', '合集'],
    featured: false,
  },
];

export type Video = typeof videos[0];

export const getVideosByCategory = (categorySlug: string) =>
  videos.filter((v) => v.categorySlug === categorySlug);

export const getFeaturedVideos = () => videos.filter((v) => v.featured);

export const getVideoBySlug = (slug: string) =>
  videos.find((v) => v.slug === slug) || null;

export const getRelatedVideos = (video: Video, limit: number = 4) =>
  videos
    .filter((v) => v.id !== video.id && v.categorySlug === video.categorySlug)
    .slice(0, limit);